const copyToClipboard = (text) => {
  const inputField = document.createElement('textarea');
  inputField.innerText = text;
  document.body.appendChild(inputField);
  inputField.select();
  document.execCommand('copy');
  inputField.remove();
};
export default copyToClipboard;
